import { FormPayload } from "@dev/ee-api/ee-api-models";
import { HistoryBackAction } from "@/services/hooks/useHistoryBackAction";

export interface ModalState {
    activationTemplateName?: string;
    isLoadingActivationTemplate: boolean;
    activationTemplateScreenshot?: string;

    isGalleryOpen: boolean;

    isLoadingDoubleOptInPage: boolean;
    searchInput?: string;
    isDoubleOptInPageError?: boolean;
    doubleOptInPageType: DoubleOptInPageTypeEnum;
    doubleOptInPageValue?: string;
    previewUrl?: string;
}

export interface FormMultiDoubleOptInCustomizeModalProps {
    historyBackAction?: HistoryBackAction,
}

export interface TemplatesList {
    label: string,
    value: string,
    image?: JSX.Element
    link?: string;
}

export enum DoubleOptInPageTypeEnum {
    Defaultpage = 'defaultpage',
    Landingpage = 'landingpage',
    Externalwebsite = 'externalwebsite',
}

export interface FormMultiDoubleOptInCustomizeModalBodyProps {
    templateFormPayload?: FormPayload,
    // newFormPayloadSaveRef: React.MutableRefObject<Partial<FormPayload>>;
    updateFormPayload: (formPayload: Partial<FormPayload>) => void,
    historyBackAction?: HistoryBackAction;
}
